// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const BeaverSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'beaver-idle',
    metadata: {
      frames: {
        'beaver-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-idle-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/idle.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-idle': [
          'beaver-idle-0',
          'beaver-idle-1',
          'beaver-idle-2',
          'beaver-idle-3',
        ],
      },
    },
  },
  {
    name: 'beaver-walk',
    metadata: {
      frames: {
        'beaver-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-walk-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/walk.png',
        size: {
          w: 896,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-walk': [
          'beaver-walk-0',
          'beaver-walk-1',
          'beaver-walk-2',
          'beaver-walk-3',
          'beaver-walk-4',
          'beaver-walk-5',
          'beaver-walk-6',
        ],
      },
    },
  },
  {
    name: 'beaver-attack1',
    metadata: {
      frames: {
        'beaver-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack1-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack1-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack1-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack1-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/attack1.png',
        size: {
          w: 640,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-attack1': [
          'beaver-attack1-0',
          'beaver-attack1-1',
          'beaver-attack1-2',
          'beaver-attack1-3',
          'beaver-attack1-4',
        ],
      },
    },
  },
  {
    name: 'beaver-attack2',
    metadata: {
      frames: {
        'beaver-attack2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-9': {
          frame: {
            x: 1152,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-10': {
          frame: {
            x: 1280,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-11': {
          frame: {
            x: 1408,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-attack2-12': {
          frame: {
            x: 1536,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/attack2.png',
        size: {
          w: 1664,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-attack2': [
          'beaver-attack2-0',
          'beaver-attack2-1',
          'beaver-attack2-2',
          'beaver-attack2-3',
          'beaver-attack2-4',
          'beaver-attack2-5',
          'beaver-attack2-6',
          'beaver-attack2-7',
          'beaver-attack2-8',
          'beaver-attack2-9',
          'beaver-attack2-10',
          'beaver-attack2-11',
          'beaver-attack2-12',
        ],
      },
    },
  },
  {
    name: 'beaver-hit',
    metadata: {
      frames: {
        'beaver-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-hit-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-hit-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-hit-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/hit.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-hit': [
          'beaver-hit-0',
          'beaver-hit-1',
          'beaver-hit-2',
          'beaver-hit-3',
        ],
      },
    },
  },
  {
    name: 'beaver-dead',
    metadata: {
      frames: {
        'beaver-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-dead-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-dead-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-dead-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-dead-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'beaver-dead-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/beaver/dead.png',
        size: {
          w: 768,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'beaver-dead': [
          'beaver-dead-0',
          'beaver-dead-1',
          'beaver-dead-2',
          'beaver-dead-3',
          'beaver-dead-4',
          'beaver-dead-5',
        ],
      },
    },
  },
];
